export const OPEN_GOOGLEMAPS_EDITOR = 'OPEN_GOOGLEMAPS_EDITOR';
export const CLOSE_GOOGLEMAPS_EDITOR = 'CLOSE_GOOGLEMAPS_EDITOR';
export const openGoogleMapsEditor = value => ({ type: OPEN_GOOGLEMAPS_EDITOR, value });
export const closeGoogleMapsEditor = () => ({ type: CLOSE_GOOGLEMAPS_EDITOR });
